import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "@/lib/api";

export const usePromo = (tick = true) => {
  const [promo, setPromo] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    client.get("/promo").then((r) => setPromo(r.data)).catch(() => {});
    const t = setInterval(() => setNow(Date.now()), tick ? 1000 : 60000);
    return () => clearInterval(t);
  }, [tick]);

  const remaining = promo ? new Date(promo.ends_at).getTime() - now : 0;

  const nextChange = promo?.next_change ? new Date(promo.next_change).getTime() - now : 1;
  useEffect(() => {
    if (tick && promo?.active && (remaining <= 0 || nextChange <= 0)) window.location.reload();
  }, [tick, promo, remaining, nextChange]);
  return { promo, remaining, active: !!promo?.active && remaining > 0 };
};

const pad = (n) => String(n).padStart(2, "0");
const ukEnd = (iso, opts) => new Date(iso).toLocaleString("en-GB", { timeZone: "Europe/London", hour: "numeric", minute: "2-digit", hour12: true, ...opts }).replace(":00", "").replace(/(\d) ([ap]m)/, "$1$2");

export const PromoBanner = () => {
  const { promo, remaining, active } = usePromo();
  if (!active) return null;
  const s = Math.floor(remaining / 1000);
  const parts = [
    ["d", Math.floor(s / 86400)],
    ["h", Math.floor((s % 86400) / 3600)],
    ["m", Math.floor((s % 3600) / 60)],
    ["s", s % 60],
  ].filter(([k, v]) => k !== "d" || v > 0);

  return (
    <Link to="/shop" data-testid="promo-banner" className="flex h-9 items-center justify-center gap-2 bg-slate-900 px-3 text-[11px] sm:text-xs font-medium text-white">
      <span className="rounded-full bg-blue-600 px-2 py-0.5 font-bold tracking-wide">{promo.all_products ? "" : "UP TO "}{promo.percent}% OFF</span>
      <span className="hidden sm:inline">{promo.all_products ? "Everything" : "Selected research"} — ends {ukEnd(promo.ends_at, { weekday: "long", day: "numeric", month: "short" })} UK</span>
      <span className="sm:hidden">Ends {ukEnd(promo.ends_at, { weekday: "short" })}</span>
      <span data-testid="promo-countdown" className="font-mono tabular-nums text-blue-300">
        {parts.map(([k, v]) => `${pad(v)}${k}`).join(" ")}
      </span>
    </Link>
  );
};

export default PromoBanner;
